import { render, staticRenderFns } from "./LiveHost.vue?vue&type=template&id=5aa5b42c&"
import script from "./LiveHost.vue?vue&type=script&lang=js&"
export * from "./LiveHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports